import React, { useState, useEffect } from 'react';

const CommentParagraph = ({ comment }) => {
  const [text, setText] = useState('');
  useEffect(() => {
    if (comment !== '') {
      const regex = /@\[.+?\]\(.+?\)/gm;
      const displayRegex = /@\[.+?\]/g;
      const idRegex = /\(.+?\)/g;
      const matches = comment?.match(regex);
      const arr = [];
      if (matches) {
        matches.forEach((m) => {
          const id = m.match(idRegex)[0].replace('(', '').replace(')', '');
          const display = m
            .match(displayRegex)[0]
            .replace('@[', '')
            .replace(']', '');

          arr.push({ id, display });
        });
      }
      const newComment = comment?.split(regex);
      let output = '';
      for (let i = 0; i < newComment?.length; i++) {
        const c = newComment[i];
        if (i === newComment?.length - 1) output += c;
        else output += `${c}<a style="color:#3A61A8" >@${arr[i]?.display}</a>`;
      }
      setText(output);
    }
  }, [comment]);

  return (
    <div>
      <p
      style={{ lineBreak: 'anywhere' }}
        className="d-inline comment-paragraph-text"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: text.replace(/\n\r?/g, '<br />')
        }}
      />
    </div>
  );
};
export default CommentParagraph;
